/**
 * Converts a string into a URL-friendly slug
 * @param text - The text to slugify (e.g., "My Project Name")
 * @returns A lowercase, hyphenated slug (e.g., "my-project-name")
 * 
 * @example
 * generateSlug("Website Redesign 2024") // "website-redesign-2024"
 * generateSlug("My Cool Project!") // "my-cool-project"
 */
export function generateSlug(text: string): string {
    return text
        .toLowerCase()
        .trim()
        // Replace spaces and underscores with hyphens
        .replace(/[\s_]+/g, '-')
        // Remove non-alphanumeric characters except hyphens
        .replace(/[^\w-]+/g, '')
        // Remove consecutive hyphens
        .replace(/--+/g, '-')
        // Remove leading/trailing hyphens
        .replace(/^-+|-+$/g, '');
}

/**
 * Generates a unique slug by appending a timestamp or random string
 * @param baseSlug - The base slug to make unique
 * @returns A unique slug with appended identifier
 * 
 * @example
 * makeSlugUnique("my-project") // "my-project-1736448000"
 */
export function makeSlugUnique(baseSlug: string): string {
    const timestamp = Date.now().toString(36); // Base36 for shorter string
    return `${baseSlug}-${timestamp}`;
}
